export default __webpack_public_path__ + "static/media/road.8b7c51e8.svg";